<template>
  <basic-container id="avue-content2021108">
    <!-- v-if="showCrud" -->
    <el-form :model="selectForm" ref="ruleForm" label-width="80px" v-show="searchBoxFlag">
        <el-row :gutter="24">
             <el-col :span="6">
                          <el-form-item label="项目名称" prop="projectId"  >
                              <el-select v-model="selectForm.projectId" style="width:100%" placeholder="项目名称" @change="projectIdChange">
                                  <el-option
                                      v-for="item in projectList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                  </el-option>
                              </el-select>
                          </el-form-item>
              </el-col>

              <el-col :span='6' >
                  <el-form-item label="设备类型" prop="typeId">
                        <avue-input-tree  :props='treeDeviceTypeProps' style="width:100%;height:32px" :disabled="!deviceTypeFlag" v-model="selectForm.typeId" placeholder="设备类型" type="tree" :dic="deviceTypeList"></avue-input-tree>
                  </el-form-item>
             </el-col>

             <el-col :span="6">
               <el-form-item label="所属部门" prop="deptId" >
                    <avue-input-tree :disabled="!deptNameFlag" style="width:100%" :props='treeDeptProps' v-model="selectForm.deptId" placeholder="所属部门" type="tree" :dic="deptList"></avue-input-tree>
                </el-form-item>
            </el-col>
             <el-col :span="6">
                <el-form-item label="设备编号" prop="code">
                        <el-input clearable v-model="selectForm.code" placeholder="设备编号" maxlength="20"></el-input>
                </el-form-item>
            </el-col>

            <el-col :span="6">
                <el-form-item label="设备名称" prop="name">
                    <el-input clearable v-model="selectForm.name" placeholder="设备名称" maxlength="20"></el-input>
                </el-form-item>
            </el-col>

            <el-col :span="6">
               <el-form-item label="资产状态" prop="assetStatus" style="width:100%" >
                             <el-select clearable  v-model="selectForm.assetStatus" placeholder="资产状态" style="width:100%" >
                                  <el-option
                                      v-for="item in assetStatusList"
                                      :key="item.dictKey"
                                      :label="item.dictValue"
                                      :value="item.dictKey">
                                  </el-option>
                              </el-select>
                          </el-form-item>
            </el-col>

            <el-col :span="6">
               <el-form-item label="使用状态" prop="useStatus">
                    <el-select clearable v-model="selectForm.useStatus" style="width:100%" placeholder="使用状态">
                                  <el-option
                                      v-for="item in useStatusList"
                                      :key="item.dictKey"
                                      :label="item.dictValue"
                                      :value="item.dictKey">
                                  </el-option>
                              </el-select>
                </el-form-item>
            </el-col>



            <el-col :span="6">
                <div style="float:right">
                              <el-button type="primary" icon="el-icon-search" size="small" @click="searchBtn" > 搜索 </el-button>
                              <el-button @click="searchClear" icon="el-icon-delete" size="small"> 清空 </el-button>
                </div>
            </el-col>


        </el-row>
    </el-form>
    <avue-crud :option="option"

               :search.sync="search"

               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               :before-close="beforeClose"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @on-load="onLoad"
               @refresh-change="searchReset"
    >
    <template slot="purchasePrice" slot-scope="scope">
              <div class="money"><span>{{tool.money_format_allowvoid(scope.row.purchasePrice)  }}</span></div>
            </template>
       <template slot="durableYears" slot-scope="scope">
              <span>{{scope.row.durableYears+"年"  }}</span>
            </template>
      <!-- @refresh-change="onLoad" -->
      <template slot="menuRight">
             <wq-showHidden :column.sync="option.column" :moduleType="400" ></wq-showHidden>
               <searchFromShow
                :searchBoxFlag.sync='searchBoxFlag'
                :removeHeight ='searchHeight'
                :option='option'
                :refOption="$refs.crud"
                ></searchFromShow>
           </template>
      <template slot="menuLeft">
        <!--        <el-button>导入</el-button>-->

        <el-button type="primary" icon="el-icon-plus" size="small"  v-if="permissionList.addBtn" @click="addFormData()"><span
          class="el-icon-add"></span>
          新 增
        </el-button>
        <el-button type="primary" size="small" @click="qrcodeDownloadDialog"><span class="el-icon-printer"></span> 打 印 标
          识 码
        </el-button>
        <!-- <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-if="permission.device_add"
          @click="exportExcelSelection"
        >导出
        </el-button> -->
        <wq-exportData :moduleType="400" @exportExcel="exportExcel"></wq-exportData>
        <!-- <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-if="permission.device_add"
          @click="exportDeviceDemoExcel"
        >导出模板
        </el-button> -->
        <el-button
          type="primary"
          size="small"
          icon="el-icon-upload2"
          @click="importDeviceForm"
          v-if="permission.device_add"
        >导入
        </el-button>
        <!--        <el-button-->
        <!--          type="primary"-->
        <!--          size="small"-->
        <!--          icon="el-icon-plus"-->
        <!--          v-if="permission.device_add"-->
        <!--          @click="exportTestDemoExcel"-->
        <!--        >导出测试！！！！-->
        <!--        </el-button>-->

      </template>
      <template slot="chargeManIdForm" slot-scope="scope">
        <el-select
          v-model="form.chargeManId"
          placeholder="责任人"
          style="width: 100%"
          clearable
        >
          <el-option
            v-for="item in userList"
            :key="item.id"
            :label="item.realNameAndPhone"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          @click="openRecordDialog(scope.row)"
        >履历
        </el-button>
        <el-button
          type="text"
          size="small"
          v-if="permissionList.editBtn"
          @click="rowEdit(scope.row)"
        >编辑
        </el-button>
        <el-button
          type="text"
          size="small"
          v-if="permissionList.delBtn"
          @click="rowDel(scope.row)"
        >删除
        </el-button>
        <el-button
          type="text"
          size="small"
          @click="copyDevice(scope.row)"
        >复制
        </el-button>
      </template>
      <template slot="fileAttachForm" slot-scope="scope">
        <vUpload :limit="10" :fileList.sync="form.fileAttach"></vUpload>
      </template>
      <template slot="imgAttachForm" slot-scope="scope">
        <vUpload :limit="1" :fileList.sync="form.imgAttach"></vUpload>
      </template>
      <template slot="projectForm" slot-scope="scope">
        <el-select
          v-model="form.project"
          placeholder="项目名称"
          style="width: 100%"
          clearable
          @change="(value) => querySelect(value,1)"
        >
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="projectIdSearch" slot-scope="scope">
        <el-select
          v-model="query.project"
          placeholder="项目名称"
          style="width: 100%"
          @change="(value) => {querySelect(value,2);getOption(value);treeByProjectDeptId(value);}"
        >
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="typeNameForm" slot-scope="scope">
        <div>
          <el-input
            v-show="typeNameFlag"
            placeholder="设备类型"
            v-model="form.typeName"
            :disabled="true"
            class="input-with-select"
          >
            <el-button
              slot="append"
              @click="typeNameFlag = false;typeIdFlag =true"
            >选择
            </el-button
            >
          </el-input>
          <el-select
            v-if="typeIdFlag"
            :value="form.typeId"
            placeholder="设备类型"
            clearable
            style="width: 100%;"
          >
            <el-option :value="form.typeId" show-all-levels :label="form.typeName">
              <el-tree
                node-key="id"
                :data="treeFormData"
                :props="treeProps"
                :load="typeLazyLoadTree"
                lazy
                @node-click="typeNodeTreeClick"
              >
              </el-tree>
            </el-option>
          </el-select>
        </div>
      </template>
      <template slot="typeNameSearch" slot-scope="scope">
        <avue-input-tree  :props='treeDeviceTypeProps' style="width:100%;height:32px" :disabled="!deviceTypeFlag&&!isEdit" v-model="form.typeId" placeholder="设备类型" type="tree" :dic="deviceTypeList"></avue-input-tree>
      </template>
      <template slot="objectTypeSearch" slot-scope="scope">
        <el-select
          v-model="query.objectType"
          placeholder="类别"
          style="width: 100%"
          @change="(value) => objectTypeSelect(value)"
          clearable
        >
          <el-option
            v-for="item in objectTypeList"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="areaNameForm" slot-scope="scope">
        <el-select
          :value="form.areaName"
          placeholder="存放区域"
          clearable
          style="width: 100%;"
        >
          <el-option :value="form.areaName" show-all-levels :label="form.areaName">
            <el-tree
              node-key="id"
              :data="treeFormAreaData"
              :props="areaTreeProps"
              :load="areaLazyLoadTree"
              lazy
              @node-click="areaNodeTreeClick"
            >
            </el-tree>
          </el-option>
        </el-select>
      </template>
      <template slot="contractIdForm" slot-scope="scope">
        <el-select
          v-model="form.contractId"
          placeholder="关联合同"
          style="width: 100%"
          clearable
        >
          <el-option
            v-for="item in contractList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="deptNameForm" slot-scope="scope">
        <el-select
          :value="form.deptName"
          placeholder="部门"
          clearable
          style="width: 100%;"
        >
          <el-option :value="form.deptName" show-all-levels :label="form.deptName">
            <el-tree
              node-key="id"
              :data="treeFormDeptData"
              :props="treeDeptProps"
              :load="deptLazyLoadTree"
              lazy
              @node-click="deptNodeTreeClick"
            >
            </el-tree>
          </el-option>
        </el-select>
      </template>
    </avue-crud>
    <el-drawer
      title="编辑"
      :visible.sync="showEditDialog"
      :modal-append-to-body="false"
      size="75%"
      @close="closeEditDialog"
      :close-on-click-modal="false"
      destroy-on-close
      append-to-body
    >
    <!-- <template slot="title">
      <h3 >编辑</h3>
    </template> -->
      <add-device-info v-if="showEditDialog" :isEdit='true' @cancle="closeAddDevice" :isAdd='false' :row="row" :showContract="false" @addForm="submitUpdateDevice"  ></add-device-info>
    </el-drawer>

    <el-dialog
      title="设备设施信息数据导入"
      append-to-body
      :visible.sync="showUploadDialog"
      :close-on-click-modal="false"
      width="555px"
      accept="vnd.ms-excel"
    >
      <avue-form v-if="showUploadDialog" :option="excelOption" ref="excelform" v-model="upload" :upload-after="uploadAfter"
                 :before-upload="beforeUpload">

        <template slot-scope="scope" slot="downloadAction">
            模板下载:
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            v-if="permission.device_add"
            @click="exportDeviceDemoExcel"
          >下载模板
          </el-button>
            <!-- <el-button @click="tip">自定义按钮</el-button> -->
        </template>
      </avue-form>
    </el-dialog>
    <el-drawer
    :close-on-click-modal="false"
      :visible.sync="recordFlag"
      :modal-append-to-body="false"
      :append-to-body="true"
      size="75%"
      title='设备履历'
      destroy-on-close
      @close="closeRecordDialog"

    >
      <!-- <h1 style="margin-left: 30px">履历</h1> -->
      <el-tabs style="margin-left: 10px" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane name="first">
          <span slot="label"
          >设备信息</span
          >
         <add-device-info ref="deviceInfoRef" v-if="recordFlag&&activeName=='first'" @cancle="closeAddDevice" :isEdit='false' :isAdd='false' :row="row" :showContract="true" @addForm="submitAddDevice"  ></add-device-info>
        </el-tab-pane>

        <el-tab-pane name="second">
          <span slot="label"
          >设备配件</span
          >
          <devicePart :row='row' ref="devicePart"></devicePart>
        </el-tab-pane>
        <el-tab-pane name="third">
          <span slot="label"
          >维保记录</span
          >
          <upkeepTaskList :row='row' ref="upkeepTaskList"></upkeepTaskList>
        </el-tab-pane>
        <el-tab-pane name="four">
          <span slot="label"
          >巡检记录</span
          >
          <inspectTask :row='row' ref="inspectTask"></inspectTask>
        </el-tab-pane>
        <el-tab-pane name="five">
          <span slot="label"
          >维修记录</span
          >
          <repairTask :row='row' ref="repairTask"></repairTask>
        </el-tab-pane>
      </el-tabs>

    </el-drawer>

    <el-drawer
      size="75%"
      :visible.sync="dialogAddFormVisible"
      title="新增"
      :modal-append-to-body="false"
      :append-to-body="true"
      :before-close="handleDrawerClose"
      :close-on-click-modal="false"
      destroy-on-close
    >

      <add-device-info v-if="dialogAddFormVisible" :isEdit='true' @addForm="submitAddDevice" :formData="addDeviceInfoForm" @cancle="closeAddDevice" ></add-device-info>

    </el-drawer>
    <qrcodeDownload
      ref="qrcodeDownload"
    ></qrcodeDownload>

    <el-dialog title="导出数据" :visible.sync="exportExcelSelectionBoxFlag" append-to-body width="30%">
        <div style="text-align:center;padding:2rem 0;">
          <el-radio v-model="exportExcelSelectionRadio" label="1">导出全部数据</el-radio>
          <el-radio v-model="exportExcelSelectionRadio" label="2">导出已选数据</el-radio>
        </div>
        <div style="text-align:center;">
          <el-button type="primary" @click="exportExcel">确定</el-button>
          <el-button type="info" @click="exportExcelSelectionBoxFlag=false">取消</el-button>
        </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  treeByProjectDeviceTypeId,
} from '@/api/crmedical/device/device';
  import {getFormTemplateByProjectId} from '@/api/form'
  import {getDeviceList} from '@/api/crmedical/device/device.js'
  import {
    add,
    getDetail,
    getList,
    remove,
    update,
    childNode,
    userList,
    copyDevice,
    getTableStructure,
    submitFormData,
    deviceExport,
    getProjectDept,
    treeByProjectDeptId
  } from "@/api/crmedical/device/device";
  import {lazyAreaTree} from "@/api/crmedical/order/order-list/order-list";
  import {mapGetters, mapState} from "vuex";
  import {tree} from "@/api/crmedical/device/devicetype";
  import devicePart from '@/views/crmedical/device/device/devicepart';
  import upkeepTaskList from '@/views/crmedical/device/upkeep/upkeeptasklist';
  import inspectTask from '@/views/crmedical/device/device/inspecttask';
  import repairTask from '@/views/crmedical/device/device/repairtask';
  import {lazyTree, getNodeByProjectId} from "@/api/crmedical/project/area";
  import {getProjectList} from "@/api/crmedical/project/project";
  import qrcodeDownload from './qrcode-download-device'
  import {getContractList} from "@/api/crmedical/upkeep/upkeepplan";
  import {getDictData} from "@/api/crmedical/contract/add";
  import {getToken} from '@/util/auth';
  import vUpload from "@/views/components/v-upload";
  import addDeviceInfo from "@/components/device/device/addDevice"
  import {addDevice,updateDevice} from '@/api/crmedical/device/addDevice';//新增设备记录
    import searchFromShow from '@/components/search-form-show/index'
  export default {
    components: {
      devicePart,
      upkeepTaskList,
      qrcodeDownload,
      inspectTask,
      repairTask,
      vUpload,
      addDeviceInfo,
      searchFromShow
    },
    data() {
      return {
        assetStatusList:[],
        selectForm:{
          projectId:'',
          typeId:'',
          deptId:'',
          code:'',
          name:'',
          useStatus:'',
          assetStatus:''
        },
        useStatusList:[],//状态条件数据集
        deptList:[],
        deptNameFlag:false,
        deviceTypeFlag:false,
        deviceTypeList:[],
        addDeviceInfoForm:{},
        row:{},
        searchFrom:{},
        exportForm:{},
        excelOption: {
          submitBtn: false,
          emptyBtn: false,
          column: [
            {
              label: '数据上传',
              prop: 'excelFile',
              type: 'upload',
              drag: true,
              loadText: '数据上传中，请稍等',
              span: 24,
              propsHttp: {
                res: 'data',
              },
              tip: '请上传 .xls,.xlsx 标准格式文件',
              action: '/api/device/imporDevice',
            },

          {
            label: '模板下载',
            prop:'downloadAction',
            formslot:true,
          }
          ],
        },
        exportExcelSelectionRadio:'1',
        exportExcelSelectionBoxFlag:false,
        showUploadDialog: false,
        showEditDialog: false,
        changeLogForm: {
          changeLogs: [],
        },
        form: {
          objectType: '',
        },
        search: {},
        showCrud: false,
        tempMainTableTemplateColumn: '',
        formTemplateData: {},
        publicColumn: [],
        extendColumn: [],
        mainColumn: [],
        addFormOption: {
          column: [],
        },
        editFormOption: {
          menuBtn: false,
          column: [],
        },
        type: '',
        dialogAddFormVisible: false,
        formTypeNameFlag: false,
        deptNameFlag: true,
        deptIdFlag: false,
        areaNameFlag: true,
        areaIdFlag: false,
        typeNameFlag: true,
        typeIdFlag: false,
        treeFormDeptData: [],
        treeFormAreaData: [],
        treeFormData: [],
        treeSearchData: [],
        typeTreeFlag: true,
        treeDeviceTypeProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
        treeProps: {
          //标题
          label: 'name',
          //值
          value: 'id',
          //子节点
          children: 'zones',
          //是否叶子节点
          isLeaf: 'hasChildren',
          //本节点类型key值
          objectType: 'id',
          //本节点类型名
          objectTypeName: 'name',
        },
        areaTreeProps: {
          //标题
          label: 'name',
          //值
          value: 'id',
          //子节点
          children: 'zones',
          //是否叶子节点
          isLeaf: 'hasChildren',
          //本节点类型key值
          objectType: 'id',
          //本节点类型名
          objectTypeName: 'name',
        },
        treeDeptProps: {
          labelText: '标题',
          label: 'title',
          value: 'id',
          children: 'children',
        },
        activeName: 'first',
        recordFlag: false,
        userList: [],
        projectList: [],
        contractList: [],
        objectTypeList: [],
        showDetpTree: true,
        showAreaTree: true,
        editForm: {},
        form: {},
        query: {
          projectId: '',
          typeName: '',
          name: '',
          code: '',
          useStatus: '',
          objectType: '',
        },
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        option: {selection: true,reserveSelection:false,
          height: 'auto',
          calcHeight: 'auto',
          tip: false,
          border: true,
          index: true,
          addBtn: false,
          viewBtn: false,
          editBtn: false,
          delBtn: false,
          indexLabel: '序号',
          columnBtn: false,
          // searchLabelWidth: 100,
          searchMenuSpan: 12,
          align:'left',
          searchMenuPosition:'right',
          column: [

            {
              searchOrder:99,
              order:99,
              showColumn:true,
              label: "项目名称",
              prop: "projectId",
              type:'select',
              dicUrl: 'api/v4ward/project/getProjectList',
              props: {
                label: 'name',
                value: 'id',
              },
              // cascaderItem: ['deptId'],
              rules: [{
                required: true,
                message: "请选择项目名称",
                trigger: "blur"
              }],
              formslot: true,
              search: false,
              searchslot: true,

              span: 6,
              typeslot: true,
            },

            {
              searchOrder:97,
              order:97,
              showColumn:true,
              label: "设备型号",
              prop: "model",
              type: 'select',

              dicUrl: 'api/v4ward/project/getProjectList',
              props: {
                label: 'name',
                value: 'id',
              },
              display: false,
              span: 6,
              typeslot: true,
            },
            {
              searchOrder:96,
              order:96,
              showColumn:true,
              label: "设备类型",
              prop: "typeName",
              rules: [{
                required: true,
                message: "请选择设备类型",
                trigger: "change"
              }],
              search: false,
              formslot: true,
              searchslot: true,
              span: 6,
              typeslot: true,
            },
            {
              searchOrder:95,
              order:95,
              showColumn:true,
              label: "所属部门",
              prop: "deptName",
              // type:'tree',
              // dicData:[],
              // props:{
              //   label:'title',
              //   value:'id',
              // },
              search: false,
              span: 6,
              // hide: true,
            },
            {
              searchOrder:94,
              order:94,
              showColumn:true,
              label: "设备编号",
              prop: "code",
              rules: [{
                required: true,
                message: "请输入设备编号",
                trigger: "change"
              }],
              search: false,
              maxlength: 20,
              showWordLimit: true,
              span: 6,
              typeslot: true,
            },
            {
              searchOrder:93,
              order:93,
              showColumn:true,
              label: "设备名称",
              prop: "name",
              rules: [{
                required: true,
                message: "请输入设备名称",
                trigger: "change"
              }],
              search: false,
              maxlength: 20,
              showWordLimit: true,
              overHidden: true,
              span: 6,
              typeslot: true,
            },



            {
              searchOrder:92,
              order:92,
              showColumn:true,
              label: "设备品牌",
              prop: "brand",
              maxlength: 10,
              showWordLimit: true,
              span: 6,
              typeslot: true,
            },
            {
              showColumn:true,
              label:'生产厂家',
              prop:'productionFactory',
            },
            {
              searchOrder:91,
              order:91,
              showColumn:true,
              label: "供货商",
              prop: "provider",
              maxlength: 20,
              showWordLimit: true,
              span: 6,
              typeslot: true,
            },
            {
              showColumn:true,
              label:'采购价格',
              prop:'purchasePrice',
              slot:true,
              align:'right'
            },
            {
              searchOrder:90,
              order:90,
              showColumn:true,
              label: "启用日期",
              prop: "startUseTime",
              rules: [{
                required: true,
                message: "请选择启用时间",
                trigger: "change"
              }],
              type: 'date',
              // type: 'datetime',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              span: 6,
              typeslot: true,
            },
            {
              showColumn:true,
              label:'资产状态',
              prop:'assetStatus',
              type: 'select',
              dataType: 'string',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
            dicUrl:
              '/api/blade-system/dict/dictionary?code=device_asset_status'
            },

            {
              searchOrder:89,
              order:89,
              showColumn:true,
              label: "保修期",
              prop: "guaranteeEndTime",
              rules: [{
                required: true,
                message: "请选择保修期",
                trigger: "change"
              }],
              type: 'date',
              // type: 'datetime',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              hide: true,
              span: 6,
              typeslot: true,
            },
            {
               showColumn:true,
               label:"使用年限",
               prop:'durableYears',
               slot:true
            },
            {
               showColumn:true,
               label:"资产属性",
               prop:'assetType',
               type: 'select',
              dataType: 'string',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dicUrl:
                '/api/blade-system/dict/dictionary?code=device_asset_type'

            },
            {
              searchOrder:83,
              order:83,
              showColumn:true,
              label: "使用状态",
              prop: "useStatus",
              display: false,
              type: 'select',
              dicUrl: '/api/blade-system/dict/dictionary?code=device_use_status',
              dataType: 'number',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              search: false,
              typeslot: true,
            },
            {
              searchOrder:88,
              order:88,
              showColumn:true,
              label: "报废日期",
              prop: "scrapTime",
              rules: [{
                required: true,
                message: "请选择报废日期",
                trigger: "change"
              }],
              type: 'date',
              // type: 'datetime',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              hide: true,
              span: 6,
              typeslot: true,
            },
            // {
            //   searchOrder:87,
            //   order:87,
            //   // showColumn:false,
            //   label: "所属部门",
            //   prop: "deptName",
            //   rules: [{
            //     required: true,
            //     message: "请选择部门",
            //     trigger: "change"
            //   }],
            //   formslot: true,
            //   hide: true,
            //   span: 6,
            //   typeslot: true,
            // },
            {
              searchOrder:86,
              order:86,
              showColumn:true,
              label: "责任人",
              prop: "chargeManName",
              rules: [{
                required: true,
                message: "请选择责任人",
                trigger: "change"
              }],
              formslot: true,
              hide: true,
              span: 6,
              typeslot: true,
            },
            {
              searchOrder:85,
              order:85,
              showColumn:true,
              label: "存放位置",
              prop: "areaName",
              rules: [{
                required: true,
                message: "请选择存放位置",
                trigger: "blur"
              }],
              formslot: true,
              hide: true,
              span: 6,
              typeslot: true,
            },
            {
              searchOrder:84,
              order:84,
              showColumn:false,
              label: "关联合同",
              prop: "contractId",
              formslot: true,
              hide: true,
              span: 6,
              typeslot: true,
            },
            {
               showColumn:true,
               label:"备注说明",
               prop:'description'
            },
            {
               showColumn:true,
               label:"第三方编码",
               width:120,
               prop:'thirdPlatformCode'
            },

            // {
            //    showColumn:true,
            //    label:"巡检标准",
            //    prop:'inspectName'
            // },
            // {
            //    showColumn:true,
            //    label:"维保标准",
            //    prop:'upkeepName'
            // },
            {
              searchOrder:82,
              order:82,
              showColumn:false,
              label: '上传图片',
              prop: 'imgAttach',
              formslot: true,
              hide: true,
              span: 24,
              typeslot: true,
            },
            {
              searchOrder:81,
              order:81,
              showColumn:false,
              label: '文件上传',
              prop: 'fileAttach',
              formslot: true,
              hide: true,
              span: 24,
              typeslot: true,
            },
          ]
        },
        addOption: {
          height: 'auto',
          calcHeight: 'auto',
          tip: false,
          border: true,
          index: true,
          addBtn: false,
          viewBtn: false,
          editBtn: false,
          delBtn: false,
          selection: true,
          indexLabel: '序号',
          columnBtn: false,
          searchLabelWidth: 100,
          searchMenuSpan: 6,
          column: [
            {
              label: "项目名称",
              prop: "projectId",
              type: 'select',

              dicUrl: 'api/v4ward/project/getProjectList',
              props: {
                label: 'name',
                value: 'id',
              },
              display: false,
              span: 6,
              typeslot: true,
            },
            {
              label: "项目名称",
              prop: "project",
              // cascaderItem: ['deptId'],
              rules: [{
                required: true,
                message: "请选择项目名称",
                trigger: "blur"
              }],
              formslot: true,
              search: true,
              searchslot: true,
              hide: true,
              span: 6,
              typeslot: true,
            },
            {
              label: "设备名称",
              prop: "name",
              rules: [{
                required: true,
                message: "请输入设备名称",
                trigger: "change"
              }],
              search: true,
              maxlength: 20,
              showWordLimit: true,
              overHidden: true,
              span: 6,
              typeslot: true,
            },
            {
              label: "类别",
              prop: "objectType",
              rules: [{
                required: true,
                message: "请选择类别",
                trigger: "blur"
              }],
              dicUrl: '/api/blade-system/dict/dictionary?code=device_object_type',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dataType: 'number',
              type: 'radio',
              search: true,
              searchslot: true,
              span: 6,
              typeslot: true,
            },
            {
              label: "设备类型",
              prop: "typeName",
              rules: [{
                required: true,
                message: "请选择设备类型",
                trigger: "change"
              }],
              search: false,
              formslot: true,
              searchslot: true,
              span: 6,
              typeslot: true,
            },
            {
              label: "设备型号",
              prop: "model",
              maxlength: 50,
              showWordLimit: true,
              span: 6,
            },
            // {
            //   label: "所属部门",
            //   prop: "deptId",
            //   type:'tree',
            //   dicData:[],
            //   props:{
            //     label:'title',
            //     value:'id',
            //   },
            //   search: true,
            //   span: 6,
            // },
            {
              label: "设备编号",
              prop: "code",
              rules: [{
                required: true,
                message: "请输入设备编号",
                trigger: "change"
              }],
              search: true,
              maxlength: 20,
              showWordLimit: true,
              span: 6,
              typeslot: true,
            },



            {
              label: "设备品牌",
              prop: "brand",
              maxlength: 10,
              showWordLimit: true,
              span: 6,
              typeslot: true,
            },

            {
              showColumn:true,
              label: "生产厂家",
              prop: "productionFactory",
              // search: true,
              maxlength: 20,
              showWordLimit: true,
              span: 6,
              typeslot: true,
            },

            {
              label: "供货商",
              prop: "provider",
              maxlength: 20,
              showWordLimit: true,
              span: 6,
              typeslot: true,
            },

            {
              label: "采购价格",
              prop: "purchasePrice",
              // search: true,
              type:'input',
              rules: [
              // {
              //   required: true,
              //   message: "请输入采购价格",
              //   trigger: "blur"
              // },
              {pattern: /(^[1-9]{1}[0-9]{2,9}$)|(^[1-9]{1}[0-9]{2,9}[\.]{1}[0-9]{1,2}$)/,message: '请輸入正确的格式', trigger: 'blur'}],
              maxlength: 13,
              showWordLimit: true,
              span: 6,
              typeslot: true,
            },
            {
              label: "启用时间",
              prop: "startUseTime",
              rules: [{
                required: true,
                message: "请选择启用时间",
                trigger: "change"
              }],
              type: 'date',
              // type: 'datetime',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              span: 6,
              typeslot: true,
            },
            {
              label: "保修期",
              prop: "guaranteeEndTime",
              rules: [{
                required: true,
                message: "请选择保修期",
                trigger: "change"
              }],
              type: 'date',
              // type: 'datetime',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              hide: true,
              span: 6,
              typeslot: true,
            },
            {
              label: "报废日期",
              prop: "scrapTime",
              rules: [{
                required: true,
                message: "请选择报废日期",
                trigger: "change"
              }],
              type: 'date',
              // type: 'datetime',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              hide: true,
              span: 6,
              typeslot: true,
            },
            // {
            //   label: "所属部门",
            //   prop: "deptName",
            //   rules: [{
            //     required: true,
            //     message: "请选择部门",
            //     trigger: "change"
            //   }],
            //   formslot: true,
            //   // hide: true,
            //   span: 6,
            //   typeslot: true,
            // },
            {
              label: "责任人",
              prop: "chargeManId",
              rules: [{
                required: true,
                message: "请选择责任人",
                trigger: "change"
              }],
              formslot: true,
              hide: true,
              span: 6,
              typeslot: true,
            },
            {
              label: "存放位置",
              prop: "areaName",
              rules: [{
                required: true,
                message: "请选择存放位置",
                trigger: "blur"
              }],
              formslot: true,
              hide: true,
              span: 6,
              typeslot: true,
            },
            {
              label: "关联合同",
              prop: "contractId",
              formslot: true,
              hide: true,
              span: 6,
              typeslot: true,
            },
            {
              label: "备注说明",
              prop: "description",
              type:'textarea',
              hide: true,
              span: 24,
              typeslot: true,
            },
            {
              label: "状态",
              prop: "useStatus",
              display: false,
              type: 'select',
              dicUrl: '/api/blade-system/dict/dictionary?code=device_use_status',
              dataType: 'number',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              search: true,
              typeslot: true,
            },
            {
              label: '上传图片',
              prop: 'imgAttach',
              formslot: true,
              hide: true,
              span: 24,
              typeslot: true,
            },
            {
              label: '文件上传',
              prop: 'fileAttach',
              formslot: true,
              hide: true,
              span: 24,
              typeslot: true,
            },
          ]
        },
        editOption: {
          labelWidth: 130,
          column: [
            {
              label: "项目名称",
              prop: "projectId",
              rules: [{
                required: true,
                message: "请选择项目名称",
                trigger: "change"
              }],
              formslot: true,
              span: 6,
            },
            {
              label: "设备名称",
              prop: "name",
              editDisabled: true,
              rules: [{
                required: true,
                message: "请输入设备名称",
                trigger: "change"
              }],
              maxlength: 20,
              showWordLimit: true,
              overHidden: true,
              span: 6,
            },
            {
              label: "类别",
              prop: "objectType",
              rules: [{
                required: true,
                message: "请选择类别",
                trigger: "blur"
              }],
              dicUrl: '/api/blade-system/dict/dictionary?code=device_object_type',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dataType: 'number',
              type: 'radio',
              span: 6,
            },
            {
              label: "设备类型",
              prop: "typeName",
              rules: [{
                required: true,
                message: "请选择设备类型",
                trigger: "change"
              }],
              formslot: true,
              span: 6,
            },
            {
              label: "设备型号",
              prop: "model",
              maxlength: 50,
              span: 6,
            },
            {
              label: "设备编号",
              prop: "code",
              rules: [{
                required: true,
                message: "请输入设备编号",
                trigger: "change"
              }],
              search: true,
              maxlength: 20,
              showWordLimit: true,
              span: 6,
            },
            {
              label: "设备品牌",
              prop: "brand",
              maxlength: 10,
              showWordLimit: true,
              span: 6,
            },
            {
              label: "生产厂家",
              prop: "productionFactory",
              // search: true,
              maxlength: 20,
              showWordLimit: true,
              span: 6,
              typeslot: true,
            },
            {
              label: "供货商",
              prop: "provider",
              maxlength: 20,
              showWordLimit: true,
              span: 6,
            },
            {
              label: "采购价格",
              prop: "purchasePrice",
              // search: true,
              type:'input',
              rules: [
              // {
              //   required: true,
              //   message: "请输入采购价格",
              //   trigger: "blur"
              // },
              {pattern: /(^[1-9]{1}[0-9]{2,9}$)|(^[1-9]{1}[0-9]{2,9}[\.]{1}[0-9]{1,2}$)/,message: '请輸入正确的格式', trigger: 'blur'}],
              maxlength: 13,
              showWordLimit: true,
              span: 6,
              typeslot: true,
            },
            {
              label: "启用时间",
              prop: "startUseTime",
              rules: [{
                required: true,
                message: "请选择启用时间",
                trigger: "change"
              }],
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd 00:00:00',
              span: 6,
            },
            {
              label: "保修期",
              prop: "guaranteeEndTime",
              rules: [{
                required: true,
                message: "请选择保修期",
                trigger: "change"
              }],
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd 00:00:00',
              hide: true,
              span: 6,
            },
            {
              label: "报废日期",
              prop: "scrapTime",
              rules: [{
                required: true,
                message: "请选择报废日期",
                trigger: "change"
              }],
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd 00:00:00',
              hide: true,
              span: 6,
            },
            // {
            //   label: "所属部门",
            //   prop: "deptName",
            //   rules: [{
            //     required: true,
            //     message: "请选择部门",
            //     trigger: "change"
            //   }],
            //   formslot: true,
            //   // hide: true,
            //   span: 6,
            // },
            {
              label: "责任人",
              prop: "chargeManId",
              rules: [{
                required: true,
                message: "请选择责任人",
                trigger: "change"
              }],
              formslot: true,
              span: 6,
            },
            {
              label: "存放位置",
              prop: "areaName",
              rules: [{
                required: true,
                message: "请选择存放位置",
                trigger: "change"
              }],
              formslot: true,
              span: 6,
            },
            {
              label: "关联合同",
              prop: "contractId",
              formslot: true,
              span: 6,
            },
            {
              label: "备注说明",
              prop: "description",
              type:'textarea',
              hide: true,
              span: 24,
              typeslot: true,
            },
            {
              label: "状态",
              prop: "useStatus",
              display: false,
              type: 'select',
              dicUrl: '/api/blade-system/dict/dictionary?code=device_use_status',
              dataType: 'number',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              search: true,
            },
            {
              label: '上传图片',
              prop: 'imgAttach',
              formslot: true,
              hide: true,
              span: 24,
            },
            {
              label: '文件上传',
              prop: 'fileAttach',
              formslot: true,
              hide: true,
              span: 24,
            },
          ]
        },
        data: [],
        record: {},
        attachIdList: [],
        showTypeName: false,
        contractIds:[],
        searchBoxFlag:true,
        searchHeight:''
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      ...mapState({
        userInfo: (state) => state.user.userInfo,
      }),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.device_add, false),
          viewBtn: this.vaildData(this.permission.device_view, false),
          delBtn: this.vaildData(this.permission.device_delete, false),
          editBtn: this.vaildData(this.permission.device_edit, false),
          exportDeviceBtn: this.vaildData(this.permission.export_device, true),
          exportDemoDeviceBtn: this.vaildData(this.permission.export_demo_device, true),
          importDeviceBtn: this.vaildData(this.permission.import_device, true),
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    watch: {
      'form.objectType': function (val) {
        if (val) {
          this.objectTypeSelect(val, 1);
        }
      },
      'editForm.objectType': function (val) {
        if (val) {
          this.objectTypeSelect(val, 2);
        }
      },
      "option.column"(){
        setTimeout(()=>{
          this.$refs.crud.selectClear();
          this.contractIds = "";
          this.search = this.exportForm;
        },0)
      },

    },
    created() {
      this.initSelect();

    },
    mounted() {
      console.log(this.$refs.crud);
       this.searchHeight = this.$refs.ruleForm .$el.clientHeight
      this.option.height = this.bodyHeight - this.searchHeight - 279;
      console.log(this.bodyHeight,this.searchHeight);
    },
    methods: {
      projectIdChange(val){
        this.selectForm.typeId = '';
        this.selectForm.deptId = '';
        this.selectForm.code = '';
        this.selectForm.name = '';
        this.selectForm.useStatus = '';
        this.selectForm.assetStatus = '';
        this.getDeptList(val);
        this.getDeviceTypeList(val);

      },
      getDeptList(value) {
      this.deptNameFlag = false;
      treeByProjectDeptId({ projectId: value }).then((res) => {
        this.deptList = res.data;
        this.deptNameFlag = true;
      });
    },
      searchBtn() {
       this.page.currentPage = 1
       this.onLoad();
      //  let deptIdCoulom = this.findObject(this.option.column ,'deptId');
      //   deptIdCoulom.value = '';
        // console.log(deptIdCoulom)
        // treeByProjectDeptId({projectId:this.selectForm.projectId}).then(res=>{
        //     deptIdCoulom.dicData = res.data;
        //
        // })

    },
    searchClear() {
      this.selectForm.typeId = '';
      this.selectForm.deptId = '';
      this.selectForm.code = '';
      this.selectForm.name = '';
      this.selectForm.useStatus = '';
      this.selectForm.assetStatus = '';
    },
      getDeviceTypeList(value) {
      this.deviceTypeFlag = false;
      console.log("进入了")
      treeByProjectDeviceTypeId({ projectId: value }).then((res) => {
        this.deviceTypeList = res.data;
        console.log('设备类型', this.deviceTypeList);
        this.deviceTypeFlag = true;
      });
      },
      closeAddDevice(){
        this.dialogAddFormVisible = false
        this.recordFlag = false
        this.showEditDialog = false
      },
      submitUpdateDevice(val){
        //编辑设备
        updateDevice(val).then(()=>{
          this.$message.success("编辑设备成功！")
          this.page.currentPage = 1
          // this.dialogAddFormVisible = false
          this.showEditDialog = false;
          this.onLoad()
        })
      },
      submitAddDevice(val){
        console.log(val)
        addDevice(val).then(()=>{
          this.$message.success("添加设备成功！")
          this.page.currentPage = 1
          this.dialogAddFormVisible = false
          this.onLoad()
        })
      },

    exportExcelSelection(){
      this.exportExcelSelectionBoxFlag = true;
    },
      // 获取部门下拉框数据
      // treeByProjectDeptId(value){
      //   console.log(value)
      //   let deptIdCoulom = this.findObject(this.option.column ,'deptId');
      //   deptIdCoulom.value = '';
      //   console.log(deptIdCoulom)
      //   // treeByProjectDeptId({projectId:value}).then(res=>{
      //   //     deptIdCoulom.dicData = res.data;
      //   //     this.onLoad();
      //   // })
      // },
      beforeUpload(){

      },
      uploadAfter(res,done){
        done();
        if(this.vdui.isEmpty(String(res))){
          this.$message.success('导入成功！');
          this.showUploadDialog = false;
          this.onLoad();
        }
      },
      assingChangeDetail(detail) {
        if (detail.attachProperty) {
          return '';
        } else {
          return '旧值为"' + detail.changeFrom + '"，新值为"' + detail.changeTo + '"';
        }
      },
      getOperateName(changeType) {
        if (changeType === 'ADD') {
          return '创建';
        } else {
          return '变更';
        }
      },
      rowEdit(row) {

        this.type = 'edit';
        this.beforeForm(row);
        this.row = row
        this.editFormOption.menuBtn = true;
        this.showEditDialog = true;
        this.loading = false;
      },
      closeEditDialog() {
        this.showEditDialog = false;
      },
      handleDrawerClose() {
        console.log(this.form);
        this.form = this.deepClone({});
        console.log(this.form);

        this.dialogAddFormVisible = false;
      },

      importDeviceForm() {
        console.log('打开上传表单...');

        this.showUploadDialog = true;
        setTimeout(()=>{

          console.log(this.$refs.excelform);
          this.$refs.excelform.form.excelFile = [];
        })
      },
      exportDeviceDemoExcel() {
        this.$confirm("是否导出模板数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          //导出设备设施模版
          window.open(`/api/device/exportTestDemoExcel?${this.website.tokenHeader}=${getToken()}&projectId=` + this.selectForm.projectId);

        });
      },
      // exportTestDemoExcel(){
      //   this.$confirm("是否导出模板数据?", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning"
      //   }).then(() => {
      //     //导出设备设施模版
      //     window.open(`/api/device/exportTestDemoExcel?${this.website.tokenHeader}=${getToken()}&projectId=`+ this.query.projectId);
      //
      //   });
      // },
      handlePictureCardPreview(file) {
        console.log(file.url)
        window.open(file.url);
      },
      exportExcel(data) {
        let saveIds = data.exportExcelSelectionRadio=='1'?'':this.contractIds;

      if(saveIds.length==0 && data.exportExcelSelectionRadio == 2){
              this.$message({
                      message:'请选择需要导出的数据！',
                      type: 'warning'
              });
              return;
      }
        this.$confirm("是否导出设备设施数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          //导出数据
            let projectId = this.exportForm.projectId;

            if(data.exportExcelSelectionRadio == 2){
              this.tool.downloadFile(`/api/v4ward/personal/config/export/default/deviceExport?${
                  this.website.tokenHeader
                }=${getToken()}&configExport=${data.configExport}&projectId=${projectId}&saveIds=${saveIds}`)

            }else{
              // 将条件参数拼接为路由传参格式
              let paramFormString = this.tool.objToform(this.exportForm);
              //
              this.tool.downloadFile(
                `/api/v4ward/personal/config/export/default/deviceExport?${
                  this.website.tokenHeader
                }=${getToken()}&configExport=${data.configExport}&${paramFormString}`,"abc.xlsx",'xlsx/xls'
                )

            }

          });
      },
      handleSubmit(form, done) {
        console.log(form);
        //  if(){

        // form.project = this.projectList[0].name;
        // form.projectId = this.projectList[0].id;
        //  }
        // this.querySelect(form.projectId, 1);
        //  form.deptId = '1123598813738675201';

        form.pageUrl = '/device';
        form.mainFields = {};
        form.publicFields = {};
        form.extendFields = {};
        console.log(form);
        if (this.publicColumn.length > 0) {
          this.publicColumn.forEach((e) => {
            form.publicFields[e.prop] = form[e.prop];
          });
        }
        if (this.mainColumn.length > 0) {

          this.mainColumn.forEach((e) => {
            form.mainFields[e.prop] = form[e.prop];
          });
          form.mainFields['typeId'] = form['typeId'];
          form.mainFields['areaId'] = form['areaId'];
          form.mainFields['deptId'] = form['deptId'];
          // let imgAttach = form.imgAttach;
          // console.log("imgAttach:" + imgAttach);
          // if (imgAttach.length !== 0) {
          //   form.mainFields['attachId'] = form.imgAttach[0].id;
          // }
          // let fileAttach = form.fileAttach;
          // console.log("fileAttach:" + fileAttach);
          // if (fileAttach.length !== 0) {
          //   let str = '';
          //   fileAttach.forEach((value, index) => {
          //     if (fileAttach.length - 1 === index) {
          //       str = str + value.id;
          //     } else {
          //       str = str + value.id + ',';
          //     }
          //   });
          //   console.log("str:" + str);
          //   form.mainFields['attachIds'] = str;
          // }
        }
        if (this.extendColumn.length > 0) {

          this.extendColumn.forEach((e) => {
            form.extendFields[e.prop] = form[e.prop];
          });
        }
        console.log(form);
        console.log(this.formTemplateData);
        if (this.formTemplateData && Object.keys(this.formTemplateData).length == 0) {
          // self.addFormOption = self.option;
          // self.dialogAddFormVisible = true;
          // return;
          form.mainFields = this.deepClone(form);
        }
        //  return;
        let form_ = {
          fields: {

            extendFields: form.extendFields,

            publicFields: form.publicFields,
            mainFields: form.mainFields,
          },
          projectId: form.projectId,
          pageUrl: form.pageUrl,
          deptId: form.deptId
        };

        let scrapTime = form_.fields.mainFields.scrapTime;
        let guaranteeEndTime = form_.fields.mainFields.guaranteeEndTime;
        let startUseTime = form_.fields.mainFields.startUseTime;
        if (scrapTime <= guaranteeEndTime || scrapTime <= startUseTime) {
          this.$message.warning('报废日期必须大于保修期和启用时间');
          done();
          return;
        }
        if (guaranteeEndTime <= startUseTime) {
          this.$message.warning('保修期必须大于启用时间');
          done();
          return;
        }
        if (form_.fields.mainFields.fileAttach && form_.fields.mainFields.fileAttach.length > 0) {

          form_.fields.mainFields.fileAttach.forEach((ele, index) => {
            if (!ele) {
              console.log("ele========>", ele);
              form_.fields.mainFields.fileAttach.splice(index, 1);
              // form_.fields.mainFields.fileAttach = form_.fields.mainFields.fileAttach.splice(index,1);
              // form_.fields.mainFields.fileAttach[index] = '';
            }
          });
        }
        if (form_.fields.mainFields.imgAttach && form_.fields.mainFields.imgAttach.length > 0) {

          form_.fields.mainFields.imgAttach.forEach((ele, index) => {
            if (!ele) {
              console.log("ele========>", ele);
              form_.fields.mainFields.imgAttach.splice(index, 1);
              // form_.fields.mainFields.imgAttach = form_.fields.mainFields.imgAttach.splice(index,1);
              // form_.fields.mainFields.imgAttach[index] = '';
            }
          });
        }
        console.log(form_);
        submitFormData(form_).then((res) => {
          this.$refs.addFormEle.resetForm();
          form = {};
          console.log('this.$refs.addFormEle========>', this.$refs.addFormEle);
          console.log(res);
          this.onLoad();
          this.$message.success('操作成功!');
          this.form = {};
          this.dialogAddFormVisible = false;
        });
        done();
        // done();
      },
      async getOption() {
        return;

      },


     addFormData(){
       this.addDeviceInfoForm={}
       this.addDeviceInfoForm.projectId = this.selectForm.projectId
       this.dialogAddFormVisible = true
     },

      editFormData() {
        let columnList = [];
        let self = this;
        // let publicColumn = [];
        // let extendColumn = [];
        // let mainColumn = [];
        this.editForm = {
          fileAttach: [],
          imgAttach: []
        };
        if (self.formTemplateData && Object.keys(self.formTemplateData).length == 0) {
          self.editFormOption = self.editOption;
          // self.dialogAddFormVisible = true;
          return;
        }
        if (self.formTemplateData.publicFormInfo.createJson) {
          self.publicColumn = self.formTemplateData.publicFormInfo.createJson.fields
        }
        if (self.formTemplateData.mainFormInfo.createJson) {
          // self.mainColumn = self.formTemplateData.mainFormInfo.createJson.column
          self.mainColumn = this.deepClone(self.editOption.column);
        }
        if (self.formTemplateData.extendFormInfo.createJson) {
          self.extendColumn = self.formTemplateData.extendFormInfo.createJson.fields
        }
        columnList = columnList.concat(self.mainColumn);
        columnList = columnList.concat(self.publicColumn);
        columnList = columnList.concat(self.extendColumn);

        self.editFormOption.column = columnList;

        // setTimeout(()=>{
        //   self.dialogAddFormVisible = true;
        // })
      },


      editTypeLazyLoadTree(node, resolve) {
        let id;
        if (node.level === 0) {
          id = 0;
        } else {
          id = node.data.id;
        }
        tree({id: id, projectId: this.editForm.projectId, objectType: this.editForm.objectType}).then(({data}) => {
          if (data instanceof Array) {
            data.forEach(item => {
              item.hasChildren = !item.hasChildren;
            })
          }
          resolve(data);
        });
      },
      editTypeNodeTreeClick(node) {
        let nodeId = node.id;
        let nodeTitle = node.name;
        this.editForm.typeName = nodeTitle;
        this.editForm.typeId = nodeId;
        this.typeNameFlag = true;
        this.typeIdFlag = false;
      },
      editAreaLazyLoadTree(node, resolve) {
        let id;
        if (node.level === 0) {
          id = 0;
        } else {
          id = node.data.id;
        }
        lazyAreaTree({parentId: id, projectId: this.query.projectId}).then(
          ({data}) => {
            if (data instanceof Array) {
              data.forEach((item) => {
                item.hasChildren = !item.hasChildren;
              });
            }
            resolve(data);
          }
        );
        // getNodeByProjectId({projectId: this.editForm.projectId}).then(({data}) => {
        //   if (data instanceof Array) {
        //     data.forEach(item => {
        //       item.hasChildren = !item.hasChildren;
        //     })
        //   }
        //   resolve(data);
        // });
      },
      editAreaNodeTreeClick(node) {
        if (parseInt(node.nodeType) == 1) {
          // this.$message.error();
          return;
        }
        let nodeId = node.id;
        let nodeTitle = node.name;
        this.editForm.areaName = nodeTitle;
        this.editForm.areaId = nodeId;
        this.areaNameFlag = true;
        this.areaIdFlag = false;
        this.showAreaTree = false;
      },
      editDeptNodeTreeClick(node) {
        let nodeId = node.value;
        let nodeTitle = node.title;
        this.editForm.deptName = nodeTitle;
        this.editForm.deptId = nodeId;
        this.editForm.chargeManId = '';
        this.deptNameFlag = true;
        this.deptIdFlag = false;
        this.showDetpTree = false;
        userList({deptId: nodeId}).then(({data}) => {
          data.forEach(item => {
            item.label = item.realNameAndPhone;
            item.value = item.id;
          })
          this.userList = data;
        })
      },

      addDeptNodeTreeClick(node) {
        let nodeId = node.value;
        let nodeTitle = node.title;
        this.form.deptName = nodeTitle;
        this.form.deptId = nodeId;
        this.form.chargeManId = '';
        this.deptNameFlag = true;
        this.deptIdFlag = false;
        this.showDetpTree = false;
        userList({deptId: nodeId}).then(({data}) => {
          data.forEach(item => {
            item.label = item.realNameAndPhone;
            item.value = item.id;
          })
          this.userList = data;
        })
      },
      deptLazyLoadTree(node, resolve) {
        let id;
        if (node.level === 0) {
          id = 0;
        } else {
          id = node.data.id;
        }
        childNode({parentId: id}).then(({data}) => {
          resolve(data);
        });
      },
      deptNodeTreeClick(node) {
        let nodeId = node.value;
        let nodeTitle = node.title;
        this.form.deptName = nodeTitle;
        this.form.deptId = nodeId;
        this.form.chargeManId = '';
        userList({deptId: nodeId}).then(({data}) => {
          console.log('data userList==>', data);
          data.forEach(item => {
            item.value = item.id;
            item.label = item.realNameAndPhone
          })
          this.userList = data;
        })
      },

      areaLazyLoadTree(node, resolve) {
        let id;
        if (node.level === 0) {
          id = 0;
        } else {
          id = node.data.id;
        }
        lazyAreaTree({parentId: id, projectId: this.form.projectId}).then(
          ({data}) => {
            if (data instanceof Array) {
              data.forEach((item) => {
                item.hasChildren = !item.hasChildren;
              });
            }
            resolve(data);
          }
        );

        // getNodeByProjectId({projectId: this.form.projectId}).then(({data}) => {
        //   if (data instanceof Array) {
        //     data.forEach(item => {
        //       item.hasChildren = !item.hasChildren;
        //     })
        //   }
        //   resolve(data);
        // });
      },
      areaNodeTreeClick(node) {
        if (parseInt(node.nodeType) == 1) {
          // this.$message.error();
          return;
        }
        let nodeId = node.id;
        let nodeTitle = node.name;
        this.form.areaName = nodeTitle;
        this.form.areaId = nodeId;

      },
      typeLazyLoadTree(node, resolve) {
        let id;
        if (node.level === 0) {
          id = 0;
        } else {
          id = node.data.id;
        }
        let projectId, objectType;
        if (this.form.projectId) {
          projectId = this.form.projectId;
          objectType = this.form.objectType;
        } else {
          projectId = this.query.projectId;
          objectType = this.query.objectType;
        }
        tree({id: id, projectId: projectId, objectType: objectType}).then(({data}) => {
          if (data instanceof Array) {
            data.forEach(item => {
              item.hasChildren = !item.hasChildren;
            })
          } else {
            data = [];
          }
          resolve(data);
        });
      },
      typeNodeTreeClick(node) {
        let nodeId = node.id;
        let nodeTitle = node.name;
        if (this.form.projectId) {
          this.form.typeName = nodeTitle;
          this.form.typeId = nodeId;
        } else {
          this.query.typeName = nodeTitle;
          this.query.typeId = nodeId;
        }
        this.typeNameFlag = true;
        this.typeIdFlag = false;
      },
      objectTypeSelect(value, type) {
        let projectId;
        if (type === 1) {
          projectId = this.form.projectId;
          this.form.typeName = '';
          this.form.typeId = '';
        } else if (type === 2) {
          //因为watch监听会导致第一次进入清空typeName，所以这里若改变objectType的值，那么就清空，若不改变不清空
          if (!this.showTypeName) {
            this.showTypeName = this.record.objectType !== this.editForm.objectType;
          }
          projectId = this.editForm.projectId
          if (this.showTypeName) {
            this.editForm.typeName = '';
            this.editForm.typeId = '';
          }
        } else {
          projectId = this.query.projectId;
          this.query.typeName = '';
          this.query.typeId = '';
        }

        tree({id: 0, projectId: projectId, objectType: value}).then(({data}) => {
          if (data instanceof Array) {
            data.forEach(item => {
              item.hasChildren = !item.hasChildren;
            })
          }
          if (type === 1 || type === 2) {
            this.treeFormData = data;
          } else {
            this.treeSearchData = data;
          }
        });
      },
      querySelect(value, type) {
        this.form.typeName = '';
        let objectType;
        if (type === 1) {
          this.form.projectId = value;
          objectType = this.form.objectType;
        } else if (type === 2) {
          this.query.projectId = value;
          objectType = this.query.objectType;
        }
        tree({id: 0, projectId: value, objectType: objectType}).then(({data}) => {
          if (data instanceof Array) {
            data.forEach(item => {
              item.hasChildren = !item.hasChildren;
            })
          }
          if (type === 1) {
            this.treeFormData = data;
          } else if (type === 2) {
            this.treeSearchData = data;
          } else {
            this.treeFormData = data;
            this.treeSearchData = data;
          }
        });
        if (type === 1) {
          this.queryAreaSelect(value);
          this.queryContractSelect(value);
          this.queryDeptSelect(value);
          this.getDeviceTypeList(value)
        }
      },
      queryDeptSelect(value) {
        this.form.deptId = '';
        this.form.deptName = '';
        getProjectDept({projectId: value}).then(({data}) => {
          this.treeFormDeptData = data;
        })
      },
      queryEditSelect(value, type) {
        if (type !== 1) {
          this.editForm.typeName = '';
          this.editForm.typeId = '';
          this.editForm.contractId = '';
          this.editForm.areaName = '';
          this.editForm.areaId = '';
          this.editForm.deptId = '';
          this.editForm.deptName = '';

        }
        getProjectDept({projectId: value}).then(({data}) => {
          this.treeFormDeptData = data;
        });
        tree({id: 0, projectId: value, objectType: this.editForm.objectType}).then(({data}) => {
          if (data instanceof Array) {
            data.forEach(item => {
              item.hasChildren = !item.hasChildren;
            })
          }
          this.treeFormData = data;
        });

        lazyTree({parentId: 0, projectId: value}).then(({data}) => {
          if (data instanceof Array) {
            data.forEach((item) => {
              item.hasChildren = !item.hasChildren;
              if (item.nodeType === 1) {
                item.disabled = true;
              }
            });
          }
          //this.treeFormAreaData = data;
        });
        // getNodeByProjectId({projectId: value}).then(({data}) => {
        //   if (data instanceof Array) {
        //     data.forEach(item => {
        //       item.hasChildren = !item.hasChildren;
        //       if(item.nodeType === 1){
        //         item.disabled = true;
        //       }
        //     })
        //   }
        //   console.log(data)
        //   this.treeFormAreaData = data;
        // });
        getContractList({projectId: value}).then(({data}) => {
          this.contractList = data;
          let isContract = false;
          let self = this;
          data.forEach(element => {
            if(element.id === self.editForm.contractId){
              isContract = true;
            }
          });
          if(!isContract){
            this.contractList.push(self.tempEditContractObj);
          }
        });
      },
      queryContractSelect(value) {
        this.form.contractId = '';
        getContractList({projectId: value}).then(({data}) => {
          this.contractList = data;
        });
      },
      queryAreaSelect(value) {
        this.form.areaName = '';
        lazyTree({parentId: 0, projectId: value}).then(({data}) => {
          if (data instanceof Array) {
            data.forEach((item) => {
              item.hasChildren = !item.hasChildren;
              if (item.nodeType === 1) {
                item.disabled = true;
              }
            });
          }
          this.treeFormAreaData = data;
        });
        // getNodeByProjectId({projectId: value}).then(({data}) => {
        //   if (data instanceof Array) {
        //     data.forEach(item => {
        //       item.hasChildren = !item.hasChildren;
        //       if(item.nodeType === 1){
        //         item.disabled = true;
        //       }
        //     })
        //   }
        //   console.log(data)
        //   this.treeFormAreaData = data;
        // });
      },
      fileHandleRemove(file, fileList) {
        let delAttachId = file.response.data.id;
        let index = this.attachIdList.indexOf(delAttachId);
        this.attachIdList.splice(index, 1);
        this.form.attachIds = this.attachIdList.join(',');
      },
      fileUploadSuccess(response, file, fileList) {
        this.attachIdList.push(response.data.id);
        this.form.attachIds = this.attachIdList.join(',');
      },
      imgUploadSuccess(response, file, fileList) {
        this.form.imgUrl = response.data.link;
        this.form.attachId = response.data.id;
      },
      editHandleRemove(file, fileList) {
        let delAttachId;
        if (file.response) {
          delAttachId = file.response.data.id;
        } else {
          delAttachId = file.id;
        }
        let index = this.attachIdList.indexOf(delAttachId);
        this.attachIdList.splice(index, 1);
        this.editForm.attachIds = this.attachIdList.join(',');
      },
      editUploadSuccess(response, file, fileList) {
        this.attachIdList.push(response.data.id);
        this.editForm.attachIds = this.attachIdList.join(',');
      },
      editImgUploadSuccess(response, file, fileList) {
        this.editForm.imgUrl = response.data.link;
        this.editForm.attachId = response.data.id;
      },
      beforeAvatarUpload(file) {
        const isLt5M = file.size / 1024 / 1024 < 5;

        if (!isLt5M) {
          this.$message.error('上传文件大小不能超过 5MB!');
        }
        return isLt5M;
      },
      // 打开二维码查看弹窗
      qrcodeDownloadDialog() {
        if (!this.selectForm.projectId) {
          this.$message({
            message: '请先选择项目',
            type: 'warning'
          });
          return;

        }
        if (this.selectionList.length == 0) {
          this.$message({
            message: '请选择设备',
            type: 'warning'
          });
          return;
        }
        console.log(this.$refs.qrcodeDownload);
        this.$refs.qrcodeDownload.getQrcodes(this.selectForm.projectId, 0, this.selectionList);

      },
      copyDevice(row) {
        this.$confirm("确定复制选择数据?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return copyDevice({id: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleClick(tab, event) {
        if (tab.name === 'first') {
          // this.openRecordDialog(this.record);
          console.log('sdsadas')

          this.$refs['deviceInfoRef'].$refs["crud"].$refs.table.doLayout()

        }
        if (tab.name === 'second') {
          // this.partOnload();
        }
        if (tab.name === 'third') {
          // this.taskListOnload();
        }
        if (tab.name === 'four') {
          // this.inspectTaskOnload();
        }
        if (tab.name === 'five') {
          // this.repairTaskOnload();
        }
      },
      repairTaskOnload() {
        //this.$refs.repairTask.openRepairTask(this.record);
      },
      inspectTaskOnload() {
        //this.$refs.inspectTask.openInspectTask(this.record);
      },
      taskListOnload() {
        // this.$refs.upkeepTaskList.onLoad(this.record);
      },
      partOnload() {
        //this.$refs.devicePart.openPart(this.record);
      },
      closeRecordDialog() {
        this.recordFlag = false;

        this.record = {};
        this.activeName = 'first';
        this.userList = [];
        this.typeNameFlag = true;
        this.typeIdFlag = false;
      },
      openRecordDialog(row) {
        // this.type = 'view';
        // this.beforeForm(row);
        // this.editFormOption.menuBtn = false;
        // var columnList = this.editFormOption.column;
        // columnList.forEach(col => {
        //   col.disabled = true;
        // });

        this.row = row
        console.log("wai",row)
        this.recordFlag = true;
      },

      beforeForm(row) {
        this.editFormData();
        this.attachIdList = [];
        this.record = row;
        this.tempEditContractObj = {};
        getDetail({id: row.id}).then(({data}) => {
          this.tempEditContractObj = {
            id: data.contractId,
            name: data.contractName
          }
          this.editForm = data;
          if (this.publicColumn.length > 0) {
            this.publicColumn.forEach((e) => {
              this.editForm[e.prop] = row[e.prop];
            });
          }
          if (this.extendColumn.length > 0) {
            this.extendColumn.forEach((e) => {
              this.editForm[e.prop] = row[e.prop];
            });
          }
          this.attachIdList = data.longs;
          this.queryEditSelect(this.editForm.projectId, 1);

          this.showTypeName = false;
          userList({deptId: this.editForm.deptId}).then(({data}) => {
            data.forEach(item => {
              item.label = item.realNameAndPhone;
              item.value = item.id;
            });
            this.userList = data;
          })
        });
      },
      submit(form, done) {
        // this.editForm.startUseTime = this.editForm.startUseTime + ' 00:00:00';
        // this.editForm.guaranteeEndTime = this.editForm.guaranteeEndTime + ' 00:00:00';
        // this.editForm.scrapTime = this.editForm.scrapTime + ' 00:00:00';


        // submitFormData

        form = this.deepClone(this.editForm);
        console.log(form);

        // form.project = this.projectList[0].name;
        // form.projectId = this.projectList[0].id;
        // this.querySelect(form.projectId, 1);
        // form.deptId = '1123598813738675201';
        form.pageUrl = '/device';
        form.mainFields = {};
        form.publicFields = {};
        form.extendFields = {};
        console.log(form);
        console.log(this.mainColumn);
        // return;
        if (this.publicColumn.length > 0) {

          this.publicColumn.forEach((e) => {
            form.publicFields[e.prop] = form[e.prop];
          });
        }
        if (this.mainColumn.length > 0) {

          this.mainColumn.forEach((e) => {
            form.mainFields[e.prop] = form[e.prop];
          });

          form.mainFields['typeId'] = form['typeId'];
          form.mainFields['areaId'] = form['areaId'];
          form.mainFields['deptId'] = form['deptId'];
          form.mainFields['id'] = form['id'];
          // let imgAttach = form.imgAttach;
          // console.log("imgAttach:" + imgAttach);
          // if (imgAttach.length !== 0) {
          //   form.mainFields['attachId'] = form.imgAttach[0].id;
          // }
          // let fileAttach = form.fileAttach;
          // console.log("fileAttach:" + fileAttach);
          // if (fileAttach.length !== 0) {
          //   let str = '';
          //   fileAttach.forEach((value, index) => {
          //     if (fileAttach.length - 1 === index) {
          //       str = str + value.id;
          //     } else {
          //       str = str + value.id + ',';
          //     }
          //   });
          //   console.log("str:" + str);
          //   form.mainFields['attachIds'] = str;
          // }
        }
        if (this.extendColumn.length > 0) {

          this.extendColumn.forEach((e) => {
            form.extendFields[e.prop] = form[e.prop];
          });
        }
        console.log(form);

        if (this.formTemplateData && Object.keys(this.formTemplateData).length == 0) {
          // self.addFormOption = self.option;
          // self.dialogAddFormVisible = true;
          // return;
          form.mainFields = this.deepClone(form);
        }
        //  return;
        let form_ = {
          fields: {
            extendFields: form.extendFields,
            publicFields: form.publicFields,
            mainFields: form.mainFields,
          },
          projectId: form.projectId,
          pageUrl: form.pageUrl,
          deptId: form.deptId
        };

        let scrapTime = form_.fields.mainFields.scrapTime;
        let guaranteeEndTime = form_.fields.mainFields.guaranteeEndTime;
        let startUseTime = form_.fields.mainFields.startUseTime;
        if (scrapTime <= guaranteeEndTime || scrapTime <= startUseTime) {
          this.$message.warning('报废日期必须大于保修期和启用时间');
          done();
          return;
        }
        if (guaranteeEndTime <= startUseTime) {
          this.$message.warning('保修期必须大于启用时间');
          done();
          return;
        }
        if (form_.fields.mainFields.fileAttach && form_.fields.mainFields.fileAttach.length > 0) {

          form_.fields.mainFields.fileAttach.forEach((ele, index) => {
            if (!ele) {
              form_.fields.mainFields.fileAttach = form_.fields.mainFields.fileAttach.splice(index, 1);
            }
          });
        }
        if (form_.fields.mainFields.imgAttach && form_.fields.mainFields.imgAttach.length > 0) {

          form_.fields.mainFields.imgAttach.forEach((ele, index) => {
            if (!ele) {
              form_.fields.mainFields.imgAttach = form_.fields.mainFields.imgAttach.splice(index, 1);
            }
          });
        }
        submitFormData(form_).then(() => {
          this.recordFlag = false;
          this.showEditDialog = false;
          this.$refs.editForm.resetForm();
          this.record = {};
          this.activeName = 'first';
          this.onLoad();
          this.$message.success('操作成功!');
          setTimeout(() => {
            done();
          }, 100)
          done();
        }, error => {
          this.$message.error('操作失败!');
          console.log(error);
        });
      },
      initSelect() {
        getDictData({code:'device_use_status'}).then(({data})=>{
          this.useStatusList = data
        })
        getDictData({code:'device_asset_status'}).then(({data})=>{
          this.assetStatusList = data
        })
        getDictData({code: 'device_object_type'}).then((data) => {
          this.objectTypeList = data.data;
          console.log(this.objectTypeList)
        });
        getProjectList().then(async(data) => {
          this.projectList = data.data;
          if (this.projectList.length > 0) {
            this.selectForm.projectId = this.projectList[0].id;
           await this.getDeptList(this.selectForm.projectId)
          //  await this.treeByProjectDeptId(this.selectForm.projectId);
           await this.getDeviceTypeList(this.selectForm.projectId)
            this.querySelect(this.projectList[0].id,)
            this.getOption();
          }
        });
      },
      rowSave(row, loading, done) {
        row.chargeManName = row.$chargeManId;
        row.startUseTime = row.startUseTime + ' 00:00:00';
        row.guaranteeEndTime = row.guaranteeEndTime + ' 00:00:00';
        row.scrapTime = row.scrapTime + ' 00:00:00';
        add(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowUpdate(row, index, loading, done) {
        update(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeClose(done, type) {
        this.treeFormData = [];
        this.userList = [];
        this.typeNameFlag = true;
        this.typeIdFlag = false;
        done();
      },
      beforeOpen(done, type) {
        if (type === 'add') {
          console.log(this.treeFormData);
          setTimeout(() => {
            this.form.project = this.projectList[0].name;
            this.form.projectId = this.projectList[0].id;
            this.querySelect(this.form.projectId, 1);
            console.log(this.treeFormData);
          });
        }
        if (["edit", "view"].includes(type)) {
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
          });
        }
        done();
      },
      searchReset() {
        this.query.code = '';
        this.query.name = '';
        this.query.typeName = '';
        this.query.typeId = '';
        this.query.useStatus = '';
        this.query.objectType = '';
        this.query.deptId = '';
        console.log("this.getOption(this.query.projectId)");
        this.getOption(this.query.projectId)
        this.onLoad();
      },
      searchChange(params, done) {
        // 使用插槽后params为空，这里注释
        // console.log(params);
        // this.query = params;
        console.log(params);
        this.query.code = params.code;
        this.query.name = params.name;
        this.query.deptId = params.deptId;
        this.query.useStatus = params.useStatus;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      // selectionChange(list) {
      //   this.selectionList = list;
      // },


    selectionChange(val){
      this.selectionList = val;
      console.log(val);
      let Ids = [];
      val.forEach(element => {
        Ids.push(element.id);
      });
      this.contractIds = Ids.join(',');
    },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        console.log("onload")

        if (this.selectForm.projectId) {
          getFormTemplateByProjectId(this.selectForm.projectId, '2', '/device').then((res) => {
            this.formTemplateData = res.data.data;
          });
          this.exportForm = JSON.parse(JSON.stringify(this.selectForm))
          getDeviceList(
            Object.assign({current: page.currentPage, size: page.pageSize}, this.selectForm)
          ).then(({data}) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            // try{
            //   console.log("success")
            //   let elementTable = document.querySelector('#avue-content2021108 > div > div > div.avue-crud > form > div')
            // // .style = "height:300px;overflow: scroll"
            // console.log("*****",elementTable)
            // elementTable.style = "height:300px;overflow: scroll"
            // }catch{
            //   console.log("出错了")
            // }


          });
        } else {
          getProjectList().then((data) => {
            this.projectList = data.data;
            getFormTemplateByProjectId(this.projectList[0].id, '2', '/device').then((res) => {
              this.formTemplateData = res.data.data;
              console.log(res.data.data);
            });
            if (this.projectList.length > 0) {
              this.selectForm.projectId = this.projectList[0].id;

              this.exportForm = JSON.parse(JSON.stringify(this.selectForm))
               getDeviceList(
            Object.assign({current: page.currentPage, size: page.pageSize}, this.selectForm)
              ).then(({data}) => {
                this.page.total = data.total;
                this.data = data.records;
                this.loading = false;

              });
                }
          });
        }
      }
    }
  };
</script>

<style lang="scss">

  .aaa11111 {
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }

    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
  }
</style>
<style scoped>
  /deep/ .el-drawer__body {
    overflow: scroll !important;
  }
  ::v-deep .avue-crud .el-form-item {
  display: block;
}
  .money{
  text-align: right;
}
</style>
